import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import VideoGallery from './components/VideoGallery'
import AnnoncesCarousel from './components/AnnoncesCarousel'
import Motivation from './components/Motivation'
import MentalGame from './components/MentalGame'
import CalculMental from './components/CalculMental'
import Footer from './components/footer'
import Formations from './components/foormation'
import  Contact  from './components/Contact'

const App = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <About />
            <Services />
            <Formations/>
            <VideoGallery />
            <AnnoncesCarousel/>
            <Motivation />
            <MentalGame />
            <CalculMental />
            <Contact/>
          </>
        } />
      </Routes>
      <Footer />
    </div>
  )
}

export default App